/* 
    Widget helper module 
*/

import { WIDGET_MODULE_MAP, WIDGET_CONFIG_MAP } from './widget-hierarchy-map';

var widgetHelper = function widgetHelper() {

    // Returns config property with custom logic
    var addColorScheme = function addColorScheme(colorScheme) {
        var updatedColorScheme = [];
        if (colorScheme !== null) {
            colorScheme.forEach(function (color) {
                updatedColorScheme.push('' + color);
            });
            return updatedColorScheme;
        }
        return colorScheme;
    };

    //Modify modelName property from config
    var modifyModelName = function modifyModelName(modelName) {
        if (modelName !== null && modelName.trim().length > 0) {
            return modelName;
        }
        return '';
    };

    //Modify cloudName property from config
    var modifyCloudName = function modifyCloudName(cloudName) {
        if (cloudName !== null && cloudName.trim().length > 0) {
            return cloudName;
        }
        return '';
    };

    var initializeConfigPropertyWithEmptyString = function initializeConfigPropertyWithEmptyString(property) {
        if (property !== null) {
            return property;
        }
        return '';
    };

    //Checks for empty strings or null and returns null
    var initializeConfigPropertyWithNull = function initializeConfigPropertyWithNull(property) {
        if (property !== null && property.length) {
            return property;
        }
        return null;
    };

    // Add widget config properties
    var modifyWidgetConfigProperties = function modifyWidgetConfigProperties(config) {
        var ColorScheme = config.ColorScheme,
            Model = config.Model,
            Cloud = config.Cloud,
            StampText = config.StampText;


        config.ColorScheme = addColorScheme(ColorScheme);
        config.Model = modifyModelName(Model);
        config.Cloud = modifyCloudName(Cloud);
        config.StampText = initializeConfigPropertyWithEmptyString(StampText);

        return config;
    };

    // Returns a widget instance depending on widget type and widget subtype for widget rendering
    var getWidgetInstanceForRendering = function getWidgetInstanceForRendering(config) {
        var Type = config.Type;
        var _WIDGET_CONFIG_MAP$Ty = WIDGET_CONFIG_MAP[Type],
            ConfigKey = _WIDGET_CONFIG_MAP$Ty.ConfigKey,
            SubTypeKey = _WIDGET_CONFIG_MAP$Ty.SubTypeKey;


        var widgetSubtype = SubTypeKey !== null ? config[ConfigKey][SubTypeKey] : SubTypeKey;
        var widgetInstance = widgetSubtype !== null ? WIDGET_MODULE_MAP[Type][widgetSubtype] : WIDGET_MODULE_MAP[Type];
        return widgetInstance;
    };

    return {
        getWidgetInstanceForRendering: getWidgetInstanceForRendering,
        modifyWidgetConfigProperties: modifyWidgetConfigProperties,
        initializeConfigPropertyWithEmptyString: initializeConfigPropertyWithEmptyString,
        initializeConfigPropertyWithNull: initializeConfigPropertyWithNull
    };
};

export default widgetHelper();